import { Modal } from 'bootstrap'

const axios = require('axios');

let keyName = {
	FORM: "Тип",
	CITY: "Регион",
	DETAIL_PAGE_URL: "Подробнее",
	EMAIL: "Электронная почта",
	ADDRESS: "Адрес",
	OWNERSHIP: "Тип собственности",
	PHONE: "Телефон",
	PRICE: "Цена",
}

function textCreation(label, value) {
	if (label && value)
		return `
		<div class="points-modal__detail">
			<span class="points-modal__detail-label">${label}:</span>
			<span class="points-modal__detail-value">${value}</span>
		</div>
		`
}

function buttonCreation(label, value) {
	if (label && value)
		return `
		<a href="${value}" class="btn btn-warning">${label}</a>
		`
}

export async function getOpenModalFunction(request, config) {
	await ymaps.ready();

	const modal = document.getElementById("points-modal");
	const modalTitle = modal.querySelector('.modal__title h5');
	const modalContent = modal.querySelector('.points-modal__content');

	const myModal = new Modal(modal);

	function openModal(id) {
		let title, content;
		let url = request.item + id + '/';

		axios.get(url)
			.then(function (res) {
				const { FORM, CITY, DETAIL_PAGE_URL, EMAIL, ADDRESS, OWNERSHIP, PHONE, PRICE, NAME } = res.data.data.item;
				const homeInfo = [
					textCreation(keyName.FORM, FORM),
					textCreation(keyName.OWNERSHIP, OWNERSHIP),
					textCreation(keyName.CITY, CITY),
					textCreation(keyName.ADDRESS, ADDRESS),
					textCreation(keyName.PHONE, PHONE),
					textCreation(keyName.EMAIL, EMAIL),
					textCreation(keyName.PRICE, PRICE),
					buttonCreation(keyName.DETAIL_PAGE_URL, DETAIL_PAGE_URL)
				]
				title = NAME;
				content = homeInfo.join('');
			})
			.catch(function (error) {
				title = 'Произошла ошибка';
				content = 'Пожалуйста, перезагрузите страницу и попробуйте еще раз.';
				console.log(error);
			})
			.then(function (res) {
				modalTitle.innerHTML = title;
				modalContent.innerHTML = content;
				myModal.show();
			});
	}

	modal.addEventListener('hidden.bs.modal', function (event) {
		while (modalTitle.firstChild) modalTitle.removeChild(modalTitle.firstChild);
		while (modalContent.firstChild) modalContent.removeChild(modalContent.firstChild);
	})

	return openModal;
}
